import _$ from 'js/api/getdata'
import Cookie from 'js/lib/cookie'
import TYPES from './types'

window.TYPES = TYPES

/**
 * 获取当前语言
 * @param commit
 * @param state
 */
export const getLanguage = ({ commit }) => {
  const lang = Cookie.get('language') || window.localStorage.getItem('language') || (navigator.language || navigator.browserLanguage).toLowerCase().substr(0, 2)
  commit(TYPES.GET_LENOVO_LANGUAGE, lang)
}

/**
 * 获取所有的LenovoData的数据
 */
export const getLenData = ({ commit }) => _$.getData('getLenData').then((res) => {
  if (res && res.data) {
    commit(TYPES.LENOVO_DATA, res.data)
    const { accountinfo = '{}' } = res.data
    const { sidebarTheme = 'white' } = JSON.parse(accountinfo)
    // commit(TYPES.Theme_Change, sidebarTheme)
  }
})

/**
 * 获取当前用户信息
 * @param commit
 * @param state
 */
export const getUserInfo = ({ commit }) => _$.getData('getUserInfo', null).then((res) => {
  if (res && res.data) { commit(TYPES.GET_USER_INFO, res.data) }
})

/**
 * 获取所有的Session
 * @auth X-LENOVO-SESS-ID
 */
export const getSession = ({ commit }) => _$.getData('getSession', null).then((res) => {
  if (res && res.data) { commit(TYPES.GET_SESSION, res.data) }
})

/**
 * 获取当前账户信息
 * @param commit
 * @param state
 */
export const getAccountInfo = ({ commit }) => {
  let data
  return _$.getData('getAccountInfo', {
    need_lenovo_quota: true,
    need_private_quota: true,
  }).then((res) => {
    if (res && res.data) { data = res.data }
    return _$.getData('getQuota', null)
  }).then((res) => {
    // 合并企业用户的空间使用情况
    if (res && res.data && data) {
      Object.assign(data, res.data)
      commit(TYPES.GET_LENOVO_ACCOUNT_INFO, data)
    }
  })
}

/**
 * 修改当前语言
 */
export const switchLanguage = ({ commit }, param) => {
  commit(TYPES.SWITCH_LENOVO_LANGUAGE, param)
}

/**
 * 获取当前自定义信息
 * @param commit
 * @param state
 */
export const getCustomizeInfo = ({ commit }) => _$.getData('getCustomizeInfo', null).then((res) => {
  if (res && res.data) { commit(TYPES.GET_LENOVO_CUSTOMIZE_INFO, res.data) }
})

/**
 * 获取当前一级域名
 * @param commit
 * @param state
 */
export const getCname = ({ commit }) => _$.getData('getCname', null).then((res) => {
  if (res && res.data) { commit(TYPES.GET_CNAME, res.data) }
})
/**
 * 获取当前用户角色
 * @param commit
 * @param state
 */
export const getUserRole = ({ commit }) => _$.getData('getUserRole', null).then((res) => {
  if (res && res.data) { commit(TYPES.GET_USER_ROLE, res.data) }
})
